/* import Vue from 'vue';
import App from './App.vue';
import vuetify from './vuetify';  // 引入你的Vuetify实例 */

import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const vuetify = new Vuetify({
})

new Vue({
  render: h => h(App),
  vuetify,
}).$mount('#app')
